export default __webpack_public_path__ + "static/media/no_content_risk.1140eead.png";